<template>
  <span class="media-recommendation">
    {{ item.description }}
  </span>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    item() {
      return this.items.find(i => i.id === this.value)
    },
    items() {
      return [
        {
          id: 'cover',
          description: this.$t('imageRecommendation', {
            width: '1920px',
            symbol: '*',
            height: '1080px',
          }),
        },
        {
          id: 'gallery',
          description: this.$t('imageRecommendation', {
            width: '1650px',
            symbol: '*',
            height: '1050px',
          }),
        },
        {
          id: 'user',
          description: this.$t('imageRecommendation', {
            width: '700px',
            symbol: '*',
            height: '700px',
          }),
        },
        {
          id: 'flatfinder',
          description: `${this.$t('imageRecommendation', {})} ${this.$t('imageFlatfinderRecommendation')}`,
        },
      ]
    },
  },

  components: {},
}
</script>

<style lang="scss">
.media-recommendation {
  font-size: 0.7em;
  font-weight: normal;
  opacity: 0.7;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: var(--border-radius);
  padding: 5px 10px;
  margin-left: auto;
}
</style>
